import React from 'react'
import { Redirect } from 'react-router-dom'

import Account from './desktop/pages/account'
import Almost from './desktop/pages/almost'
import Browse from './desktop/pages/browse'
import Confirm from './desktop/pages/confirm'
import ForgotPassword from './desktop/pages/forgot-password'
import Genre from './desktop/pages/genre'
import Home from './desktop/pages/home'
import Login from './desktop/pages/login'
import NotFound from './desktop/pages/notfound'
import RouteWithAuth from './common/components/route-with-auth'
import Signup from './desktop/pages/signup'
import Watch from './desktop/pages/watch'
import {
	HTML_TAG_CLASS_NAMES,
	META_TAGS,
	PATH_NAMES,
} from './common/constants'

const Routes = [
	{
		content: Home,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.HOME,
		//isAuthorizedRedirect: true,
		metaDescription: META_TAGS.SITE_DESCRIPTION,
		pageTitle: META_TAGS.HOME_PAGE_TITLE,
		path: PATH_NAMES.HOME,
	},
	{
		content: Login,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.LOGIN,
		//isAuthorizedRedirect: true,
		path: PATH_NAMES.LOGIN,
	},
	{
		content: Signup,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.SIGNUP,
		//isAuthorizedRedirect: true,
		path: PATH_NAMES.SIGNUP,
	},
	{
		content: Almost,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.ALMOST,
		//isAuthorizedRedirect: true,
		path: PATH_NAMES.ALMOST,
	},
	{
		content: Confirm,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.CONFIRM,
		//isAuthorizedRedirect: true,
		path: PATH_NAMES.CONFIRM,
	},
	{
		content: ForgotPassword,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.FORGOT_PASSWORD,
		path: PATH_NAMES.FORGOT_PASSWORD,
	},
	{
		//authorizationRequired: true,
		content: Account,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.ACCOUNT,
		path: PATH_NAMES.ACCOUNT,
	},
	{
		//authorizationRequired: true,
		content: Browse,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.BROWSE,
		path: PATH_NAMES.BROWSE,
	},
	{
		//authorizationRequired: true,
		content: Genre,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.GENRE,
		path: PATH_NAMES.GENRE,
	},
	{
		//authorizationRequired: true,
		content: Watch,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.WATCH,
		path: PATH_NAMES.WATCH,
	},
	{
		content: NotFound,
		exact: true,
		htmlTagClassName: HTML_TAG_CLASS_NAMES.NOTFOUND,
		path: PATH_NAMES.NOTFOUND,
	},
]

const RoutesWithAuth = Routes.map((route, i) => {
	return (
		<RouteWithAuth
			key={i}
			authorizationRequired={route.authorizationRequired}
			content={route.content}
			exact={route.exact}
			htmlTagClassName={route.htmlTagClassName}
			isAuthorizedRedirect={route.isAuthorizedRedirect}
			metaDescription={route.metaDescription}
			path={route.path}
			pageTitle={route.pageTitle}
		/>
	)
})

// append catch all to the end
// any undefined path will redirect to "Not Found"
RoutesWithAuth.push(<Redirect key={Routes.length} to={PATH_NAMES.NOTFOUND} />)

export default RoutesWithAuth



// WEBPACK FOOTER //
// ./src/routes-desktop.js